import React from 'react'
import PropTypes from 'prop-types'
import styles from './bulletPointsDescription.module.css'
import Heading from '../heading'

const BulletPointsDescription = ({ bulletPoints = [] }) => {
  return (
    <ul className={styles.BulletPointsDescription__Container}>
      {bulletPoints.map((bulletPoint, index) => (
        <li key={`${index}-${bulletPoint}`}>
          <Heading text={bulletPoint} Element="h5" />
        </li>
      ))}
    </ul>
  )
}

BulletPointsDescription.propTypes = {
  bulletPoints: PropTypes.array,
}

export default BulletPointsDescription
